export default __webpack_public_path__ + "static/media/fasting_happened@2x.349ea093.jpg";